import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import { FormControl, FormHelperText } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import MenuItem from '@material-ui/core/MenuItem';

import {
  getByTitularidade,
} from '../../../../services/usuario/UsuarioService';
import {getTitularidades} from "../../../../services/usuario/TitularidadeService";
import {getEntidades} from "../../../../services/usuario/EntidadeService";
import {getConselhos} from "../../../../services/usuario/ConselhoService";


const InterlocutorForm = (props) => {
  const { form, onChange, children, handleChangeLista } = props;
  const [titularidades, setTitularidades] = useState([]);
  const [entidades, setEntidades] = useState([]);
  const [conselhos, setConselhos] = useState([]);
  const [conselheiros, setConselheiros] = useState([]);
  const { register, errors, clearError, setValue } = useFormContext();

  useEffect(() => {
    register({ name: 'idEntidadeConselheiro' }, { required: 'Entidade do conselheiro é obrigatório' });
    register({ name: 'idTitularidadeConselheiro' }, { required: 'Titularidade do conselheiro é obrigatório' });
    register({ name: 'idConselheiro' }, { required: 'Nome do conselheiro é obrigatório' });
    register({ name: 'ocupacaoInterlocutor' }, { required: 'Função na entidade é obrigatório' });
    register({ name: 'idConselhoInterlocutor' }, { required: 'Conselho/comissão/comitê é obrigatório' });

    setValue('idEntidadeConselheiro', form.interlocutorPerfil.idEntidadeConselheiro);
    setValue('idTitularidadeConselheiro', form.interlocutorPerfil.idTitularidadeConselheiro);
    setValue('idConselheiro', form.interlocutorPerfil.idConselheiro);
    setValue('idConselhoInterlocutor', form.interlocutorPerfil.idConselho);
    setValue('ocupacaoInterlocutor', form.ocupacao);
  }, [])
  const getConselheirosByTitularidade = async () => {

    if (form?.interlocutorPerfil?.idTitularidadeConselheiro && form?.idAtuacao) {
      const response = await getByTitularidade(form.interlocutorPerfil.idTitularidadeConselheiro, form.idAtuacao);
      const { data } = response;
      setConselheiros(data);
    }

  }


  useEffect(() => {
    getConselheirosByTitularidade();
  }, [form.interlocutorPerfil.idTitularidadeConselheiro, form.idAtuacao])


  useEffect(() => {
    getTitularidades().then((response) => setTitularidades(response.data));
    getEntidades().then((response) => setEntidades(response.data));
    getConselhos().then((response) => setConselhos(response.data));

  }, []);

  return (
    <>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={!!errors.idEntidadeConselheiro}>
          <FormLabel shrink="true">Entidade do conselheiro</FormLabel>
          <Select
            required
            id="idEntidadeConselheiro"
            name="idEntidadeConselheiro"
            value={form.interlocutorPerfil.idEntidadeConselheiro}
            onChange={onChange}
            fullWidth
            variant="outlined"
            IconComponent={ExpandMoreIcon}
          >
            {entidades.map((entidade) => (
              <MenuItem
                key={entidade.id}
                value={entidade.id}
              >
                {entidade.descricao}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors.idEntidadeConselheiro && errors.idEntidadeConselheiro.message}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Função na entidade"
          id="ocupacaoInterlocutor"
          name="ocupacaoInterlocutor"
          defaultValue={form.ocupacao}
          onChange={handleChangeLista}
          variant="outlined"
          margin="normal"
          InputLabelProps={{ shrink: true }}
          error={!!errors.ocupacaoInterlocutor}
          helperText={errors?.ocupacaoInterlocutor?.message}
          inputRef={register({
            required: 'Função na entidade é obrigatório',
          })}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={!!errors.idTitularidadeConselheiro}>
          <FormLabel shrink="true">Titularidade do conselheiro</FormLabel>
          <Select
            fullWidth
            required
            id="idTitularidadeConselheiro"
            name="idTitularidadeConselheiro"
            value={form.interlocutorPerfil.idTitularidadeConselheiro}
            onChange={onChange}
            variant="outlined"
            IconComponent={ExpandMoreIcon}
          >

            {titularidades.map((titularidade) => (
              <MenuItem
                key={titularidade.id}
                value={titularidade.id}
              >
                {titularidade.descricao}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors.idTitularidadeConselheiro && errors.idTitularidadeConselheiro.message}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={!!errors.idConselheiro}>
          <FormLabel shrink="true">Nome do conselheiro</FormLabel>
          <Select
            required
            fullWidth
            id="idConselheiro"
            name="idConselheiro"
            value={form.interlocutorPerfil.idConselheiro}
            onChange={onChange}
            variant="outlined"
            IconComponent={ExpandMoreIcon}
          >
            {conselheiros.map((conselheiro) => (
              <MenuItem
                key={conselheiro.id}
                value={conselheiro.id}
              >
                {conselheiro.nomeUsuario}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors.idConselheiro && errors.idConselheiro.message}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={!!errors.idConselho}>
          <FormLabel shrink="true">Conselho/comissão/comitê</FormLabel>
          <Select
            required
            fullWidth
            id="idConselhoInterlocutor"
            name="idConselhoInterlocutor"
            value={form.interlocutorPerfil.idConselho}
            onChange={onChange}
            variant="outlined"
            IconComponent={ExpandMoreIcon}
          >
            {conselhos.map((conselho) => (
              <MenuItem
                key={conselho.id}
                value={conselho.id}
              >
                {conselho.descricao}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors?.idConselhoInterlocutor?.message}</FormHelperText>
        </FormControl>
      </Grid>
      {children}
    </>
  );
};

export default InterlocutorForm;
